import React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import ButtonGroupToggle from './ButtonGroupToggle';

import { useState } from 'react';
import useDistanceData from '../hooks/useDistanceData';
import useDownpaymentData from '../hooks/useDownpaymentData';
import useTimeData from '../hooks/useTimeData';


const TimeAndDistance = () => {
    const [rangeValue, setRangeValue] = useState(0);
    const { time_options, getSelectedTime, setSelectedTime } = useTimeData();
    const { distance_options, getSelectedDistance, setSelectedDistance } = useDistanceData();
    const { downpayment_percentage, setDownPaymentPercentage } = useDownpaymentData();

    
    const debouncedSetDownPaymentPercentage = useDebouncedCallback(value => {
        setDownPaymentPercentage(value)
    }, 500)

    const handleTimeChange = (option) => {
        setSelectedTime(option)

        // SEO google dataLayer
        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_one_personal',
            'eventAction': 'tiempo_uso',
            'eventLabel': `${option.value}m`
        });
    }

    const handleDistanceChange = (option) => {
        setSelectedDistance(option)

        // SEO google dataLayer
        let kms;
        if (option.value === 10000) kms = '10km';
        if (option.value === 12000) kms = '12km';
        if (option.value === 15000) kms = '15km';
        if (option.value === 18000) kms = '18km';
        if (option.value === 20000) kms = '20km';
        if (option.value === 24000) kms = '24km';

        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_one_personal',
            'eventAction': 'kilometros',
            'eventLabel': kms
        });
    }

    const handleRangeChange = (e) => {
        setDownPaymentPercentage(e.target.value);

        // SEO google dataLayer
        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_one_personal',
            'eventAction': 'porcentaje_pie',
            'eventLabel': e.target.value
        });
    };


    const handleInternalRangeChange = (e) => {
        const target = e.target;
        const min = target.min;
        const max = target.max;
        const val = target.value;
        
        target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
        setRangeValue(target.value);
    }

    return (
        <>
            <div className="form-row-group">
                <div className="form-row">
                    <label>Duración</label>
                    <select className="form-control" onChange={(e) => {
                        const selectedOption = time_options.find(opt => opt.value === parseInt(e.target.value));
                        if (selectedOption) handleTimeChange(selectedOption);
                    }} value={getSelectedTime().value}>
                        {time_options.map(item => (
                            <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                    </select>
                </div>

                <div className="form-row">
                    <label>Kilometraje</label>
                    <select className="form-control" onChange={(e) => {
                        const selectedOption = distance_options.find(opt => opt.value === parseInt(e.target.value));
                        if (selectedOption) handleDistanceChange(selectedOption);
                    }} value={getSelectedDistance().value}>
                        {distance_options.map(item => (
                            <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className='downpayment-disclaimer'>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75C5.22715 0.75 0.75 5.22715 0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75Z" stroke="#00708D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10.75 14.75V9.75M10.75 6.75H10.76" stroke="#00708D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <p>Porcentaje de pie 0%.</p>
            </div>
        </>
    )

}

export default TimeAndDistance;